import React from 'react';
import { ChangePortionPosition } from './components/ChangePortionPosition';
import { ChangePortionPositionState } from './changePortionPositionState/ChangePortionPositionState';

export const ChangePortionPositionPage: React.FC = () => {
	return (
		<ChangePortionPositionState>
			<ChangePortionPosition />
		</ChangePortionPositionState>
	);
};
